module.exports = __webpack_public_path__ + "img/icon_logout.add64ca6.svg";